<section class="h-full w-full" aria-label="Tipo de conteudo">
  <div class="flex items-center justify-between gap-4">
    <h3 class="text-base leading-7 text-lWhite">Tipo de conteúdo:</h3>

    @if (selectedOption) {
      <div class="inline-flex items-center gap-2">
        <span
          class="inline-flex items-center gap-1 rounded-full bg-lBlack px-3 py-1 text-xs font-medium text-lWhite"
        >
          <l-icon class="text-sm">{{ selectedOption.icon }}</l-icon>
          {{ selectedOption.title }}
        </span>

        <button
          type="button"
          class="inline-flex h-6 w-6 items-center justify-center rounded-full text-lGray300 transition-colors hover:text-lWhite"
          aria-label="Editar tipo de conteúdo"
          (click)="onChangeType(); $event.stopPropagation()"
        >
          <l-icon class="text-sm">edit</l-icon>
        </button>
      </div>
    }
  </div>

  @if (!selectedType) {
    <div class="flex flex-col gap-3">
      @for (option of options; track option.id) {
        <article
          class="flex cursor-pointer items-center justify-between gap-4 rounded-2xl border px-5 py-3 transition-colors duration-200 hover:bg-lGray950"
          [ngClass]="{
            'border border-lPrimary bg-lGray950': isSelected(option.id),
          }"
          (click)="onPreviewType(option.id)"
        >
          <div class="flex min-w-0 items-center gap-4">
            <l-icon
              class="shrink-0 text-lg"
              [class.text-lPrimary]="isSelected(option.id)"
              [class.text-lGray600]="!isSelected(option.id)"
            >
              {{ option.icon }}
            </l-icon>

            <div class="min-w-0">
              <p class="truncate text-lg font-medium leading-6 text-lWhite">{{ option.title }}</p>
              <p class="truncate text-xs leading-5 text-lGray500">{{ option.description }}</p>
            </div>
          </div>

          @if (isSelected(option.id)) {
            <button
              type="button"
              class="shrink-0 rounded-lg bg-lPrimary px-4 py-2 text-sm font-medium leading-5 text-white transition duration-200 hover:brightness-110"
              (click)="onSelect(option.id); $event.stopPropagation()"
            >
              Selecionar
            </button>
          }
        </article>
      }
    </div>
  } @else {
    <div class="my-4 h-px w-full bg-lGray700"></div>

    @switch (selectedType) {
      @case (contentType.VIDEO) {
        <l-course-content-type-video
          [form]="form"
          [file]="uploadState.video?.file ?? null"
          [fileSizeLabel]="uploadState.video?.fileSizeLabel ?? ''"
          (fileStateChange)="onVideoFileStateChange($event)"
          (thumbnailFileChange)="onThumbnailFileChange($event)"
        />
      }

      @case (contentType.RICH_TEXT) {
        <l-course-content-type-text-editor [form]="form" />
      }

      @case (contentType.YOUTUBE) {
        <l-course-content-type-youtube
          [form]="form"
          [preview]="uploadState.youtube?.preview ?? null"
          (previewChange)="onYoutubePreviewChange($event)"
        />
      }

      @case (contentType.VIMEO) {
        <l-course-content-type-vimeo
          [form]="form"
          [preview]="uploadState.vimeo?.preview ?? null"
          (previewChange)="onVimeoPreviewChange($event)"
        />
      }

      @case (contentType.HTML) {
        <l-course-content-type-web-page
          [form]="form"
          [file]="uploadState.webPage?.file ?? null"
          [fileSizeLabel]="uploadState.webPage?.fileSizeLabel ?? ''"
          (fileStateChange)="onWebPageFileStateChange($event)"
        />
      }

      @default {
        <div class="rounded-2xl border border-lGray700 bg-lGray950 p-6 text-sm text-lGray500">
          Tipo selecionado sem formulário visual nesta etapa.
        </div>
      }
    }
  }
</section>
